import { render, staticRenderFns } from "./moveNavigation.vue?vue&type=template&id=37b282da&scoped=true&"
import script from "./moveNavigation.vue?vue&type=script&lang=js&"
export * from "./moveNavigation.vue?vue&type=script&lang=js&"
import style0 from "./moveNavigation.vue?vue&type=style&index=0&id=37b282da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b282da",
  null
  
)

export default component.exports